import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";

import { AIPromptModel } from "./aiPrompts.model";


export const aiPromptsStore = createStore({ name: "ai-prompts" }, withEntities<AIPromptModel>(), withRequestsStatus());
